import { parseWoodworkIndex, type WoodworkCatalog } from './parseWoodworkIndex'
import { woodworkIndexUrl } from '../config/media'

export async function getWoodworkIndex(): Promise<WoodworkCatalog> {
  const response = await fetch(woodworkIndexUrl, {
    headers: { Accept: 'application/json' }
  })

  if (!response.ok) {
    throw new Error(`Woodwork index ${response.status} at ${woodworkIndexUrl}`)
  }

  const data: unknown = await response.json()
  return parseWoodworkIndex(data)
}
